"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryEVMMarketResponse = exports.QueryEVMMarketRequest = exports.QueryControlledParamsResponse = exports.QueryControlledParamsRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryUserFeeStructuresResponse = exports.QueryUserFeeStructuresRequest = exports.QueryAllFeeStructuresResponse = exports.QueryAllFeeStructuresRequest = exports.QueryAllStakeEquivalenceResponse = exports.QueryAllStakeEquivalenceRequest = exports.QueryGetFeeTiersResponse = exports.QueryGetFeeTiersRequest = exports.QueryGetTradingFeesResponse = exports.QueryGetTradingFeesRequest = exports.QueryAllMarketResponse = exports.QueryAllMarketRequest = exports.QueryGetMarketResponse = exports.QueryGetMarketRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const market_1 = require("./market");
const pagination_1 = require("../../../cosmos/base/query/v1beta1/pagination");
const fee_1 = require("./fee");
const params_1 = require("./params");
exports.protobufPackage = "Switcheo.carbon.market";
const baseQueryGetMarketRequest = { id: "" };
exports.QueryGetMarketRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetMarketRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetMarketRequest);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryGetMarketRequest);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryGetMarketResponse = {};
exports.QueryGetMarketResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.marketId !== undefined) {
            market_1.Market.encode(message.marketId, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetMarketResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.marketId = market_1.Market.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetMarketResponse);
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? market_1.Market.fromJSON(object.marketId)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.marketId !== undefined &&
            (obj.marketId = message.marketId
                ? market_1.Market.toJSON(message.marketId)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetMarketResponse);
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? market_1.Market.fromPartial(object.marketId)
                : undefined;
        return message;
    },
};
const baseQueryAllMarketRequest = {};
exports.QueryAllMarketRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllMarketRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllMarketRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllMarketRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllMarketResponse = {};
exports.QueryAllMarketResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.markets) {
            market_1.Market.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllMarketResponse);
        message.markets = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.markets.push(market_1.Market.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllMarketResponse);
        message.markets = ((_a = object.markets) !== null && _a !== void 0 ? _a : []).map((e) => market_1.Market.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.markets) {
            obj.markets = message.markets.map((e) => e ? market_1.Market.toJSON(e) : undefined);
        }
        else {
            obj.markets = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllMarketResponse);
        message.markets = ((_a = object.markets) !== null && _a !== void 0 ? _a : []).map((e) => market_1.Market.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryGetTradingFeesRequest = {
    marketId: "",
    userAddress: "",
};
exports.QueryGetTradingFeesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.marketId !== "") {
            writer.uint32(10).string(message.marketId);
        }
        if (message.userAddress !== "") {
            writer.uint32(18).string(message.userAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetTradingFeesRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.marketId = reader.string();
                    break;
                case 2:
                    message.userAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetTradingFeesRequest);
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        message.userAddress =
            object.userAddress !== undefined && object.userAddress !== null
                ? String(object.userAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.marketId !== undefined && (obj.marketId = message.marketId);
        message.userAddress !== undefined &&
            (obj.userAddress = message.userAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryGetTradingFeesRequest);
        message.marketId = (_a = object.marketId) !== null && _a !== void 0 ? _a : "";
        message.userAddress = (_b = object.userAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryGetTradingFeesResponse = {};
exports.QueryGetTradingFeesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.fees !== undefined) {
            fee_1.TradingFees.encode(message.fees, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetTradingFeesResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fees = fee_1.TradingFees.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetTradingFeesResponse);
        message.fees =
            object.fees !== undefined && object.fees !== null
                ? fee_1.TradingFees.fromJSON(object.fees)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.fees !== undefined &&
            (obj.fees = message.fees ? fee_1.TradingFees.toJSON(message.fees) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetTradingFeesResponse);
        message.fees =
            object.fees !== undefined && object.fees !== null
                ? fee_1.TradingFees.fromPartial(object.fees)
                : undefined;
        return message;
    },
};
const baseQueryGetFeeTiersRequest = {
    marketType: "",
    marketId: "",
    userAddress: "",
};
exports.QueryGetFeeTiersRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.marketType !== "") {
            writer.uint32(10).string(message.marketType);
        }
        if (message.marketId !== "") {
            writer.uint32(18).string(message.marketId);
        }
        if (message.userAddress !== "") {
            writer.uint32(26).string(message.userAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetFeeTiersRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.marketType = reader.string();
                    break;
                case 2:
                    message.marketId = reader.string();
                    break;
                case 3:
                    message.userAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetFeeTiersRequest);
        message.marketType =
            object.marketType !== undefined && object.marketType !== null
                ? String(object.marketType)
                : "";
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        message.userAddress =
            object.userAddress !== undefined && object.userAddress !== null
                ? String(object.userAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.marketType !== undefined && (obj.marketType = message.marketType);
        message.marketId !== undefined && (obj.marketId = message.marketId);
        message.userAddress !== undefined &&
            (obj.userAddress = message.userAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseQueryGetFeeTiersRequest);
        message.marketType = (_a = object.marketType) !== null && _a !== void 0 ? _a : "";
        message.marketId = (_b = object.marketId) !== null && _b !== void 0 ? _b : "";
        message.userAddress = (_c = object.userAddress) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseQueryGetFeeTiersResponse = {};
exports.QueryGetFeeTiersResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.feeTiers) {
            fee_1.FeeTier.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetFeeTiersResponse);
        message.feeTiers = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.feeTiers.push(fee_1.FeeTier.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryGetFeeTiersResponse);
        message.feeTiers = ((_a = object.feeTiers) !== null && _a !== void 0 ? _a : []).map((e) => fee_1.FeeTier.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.feeTiers) {
            obj.feeTiers = message.feeTiers.map((e) => e ? fee_1.FeeTier.toJSON(e) : undefined);
        }
        else {
            obj.feeTiers = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryGetFeeTiersResponse);
        message.feeTiers = ((_a = object.feeTiers) !== null && _a !== void 0 ? _a : []).map((e) => fee_1.FeeTier.fromPartial(e));
        return message;
    },
};
const baseQueryAllStakeEquivalenceRequest = {};
exports.QueryAllStakeEquivalenceRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllStakeEquivalenceRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryAllStakeEquivalenceRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryAllStakeEquivalenceRequest);
        return message;
    },
};
const baseQueryAllStakeEquivalenceResponse = {};
exports.QueryAllStakeEquivalenceResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.stakeEquivalence) {
            fee_1.StakeEquivalence.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllStakeEquivalenceResponse);
        message.stakeEquivalence = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.stakeEquivalence.push(fee_1.StakeEquivalence.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllStakeEquivalenceResponse);
        message.stakeEquivalence = ((_a = object.stakeEquivalence) !== null && _a !== void 0 ? _a : []).map((e) => fee_1.StakeEquivalence.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.stakeEquivalence) {
            obj.stakeEquivalence = message.stakeEquivalence.map((e) => e ? fee_1.StakeEquivalence.toJSON(e) : undefined);
        }
        else {
            obj.stakeEquivalence = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllStakeEquivalenceResponse);
        message.stakeEquivalence = ((_a = object.stakeEquivalence) !== null && _a !== void 0 ? _a : []).map((e) => fee_1.StakeEquivalence.fromPartial(e));
        return message;
    },
};
const baseQueryAllFeeStructuresRequest = {};
exports.QueryAllFeeStructuresRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllFeeStructuresRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryAllFeeStructuresRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryAllFeeStructuresRequest);
        return message;
    },
};
const baseQueryAllFeeStructuresResponse = {};
exports.QueryAllFeeStructuresResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.feeStructures) {
            fee_1.FeeStructure.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllFeeStructuresResponse);
        message.feeStructures = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.feeStructures.push(fee_1.FeeStructure.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllFeeStructuresResponse);
        message.feeStructures = ((_a = object.feeStructures) !== null && _a !== void 0 ? _a : []).map((e) => fee_1.FeeStructure.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.feeStructures) {
            obj.feeStructures = message.feeStructures.map((e) => e ? fee_1.FeeStructure.toJSON(e) : undefined);
        }
        else {
            obj.feeStructures = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllFeeStructuresResponse);
        message.feeStructures = ((_a = object.feeStructures) !== null && _a !== void 0 ? _a : []).map((e) => fee_1.FeeStructure.fromPartial(e));
        return message;
    },
};
const baseQueryUserFeeStructuresRequest = { userAddress: "" };
exports.QueryUserFeeStructuresRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userAddress !== "") {
            writer.uint32(10).string(message.userAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryUserFeeStructuresRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryUserFeeStructuresRequest);
        message.userAddress =
            object.userAddress !== undefined && object.userAddress !== null
                ? String(object.userAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.userAddress !== undefined &&
            (obj.userAddress = message.userAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryUserFeeStructuresRequest);
        message.userAddress = (_a = object.userAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryUserFeeStructuresResponse = {};
exports.QueryUserFeeStructuresResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.feeStructures) {
            fee_1.FeeStructure.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryUserFeeStructuresResponse);
        message.feeStructures = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.feeStructures.push(fee_1.FeeStructure.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryUserFeeStructuresResponse);
        message.feeStructures = ((_a = object.feeStructures) !== null && _a !== void 0 ? _a : []).map((e) => fee_1.FeeStructure.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.feeStructures) {
            obj.feeStructures = message.feeStructures.map((e) => e ? fee_1.FeeStructure.toJSON(e) : undefined);
        }
        else {
            obj.feeStructures = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryUserFeeStructuresResponse);
        message.feeStructures = ((_a = object.feeStructures) !== null && _a !== void 0 ? _a : []).map((e) => fee_1.FeeStructure.fromPartial(e));
        return message;
    },
};
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseQueryControlledParamsRequest = {};
exports.QueryControlledParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryControlledParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryControlledParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryControlledParamsRequest);
        return message;
    },
};
const baseQueryControlledParamsResponse = {};
exports.QueryControlledParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.controlledParams !== undefined) {
            market_1.ControlledParams.encode(message.controlledParams, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryControlledParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.controlledParams = market_1.ControlledParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryControlledParamsResponse);
        message.controlledParams =
            object.controlledParams !== undefined && object.controlledParams !== null
                ? market_1.ControlledParams.fromJSON(object.controlledParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.controlledParams !== undefined &&
            (obj.controlledParams = message.controlledParams
                ? market_1.ControlledParams.toJSON(message.controlledParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryControlledParamsResponse);
        message.controlledParams =
            object.controlledParams !== undefined && object.controlledParams !== null
                ? market_1.ControlledParams.fromPartial(object.controlledParams)
                : undefined;
        return message;
    },
};
const baseQueryEVMMarketRequest = { contractAddress: "", name: "" };
exports.QueryEVMMarketRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.contractAddress !== "") {
            writer.uint32(10).string(message.contractAddress);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryEVMMarketRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.contractAddress = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryEVMMarketRequest);
        message.contractAddress =
            object.contractAddress !== undefined && object.contractAddress !== null
                ? String(object.contractAddress)
                : "";
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.contractAddress !== undefined &&
            (obj.contractAddress = message.contractAddress);
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryEVMMarketRequest);
        message.contractAddress = (_a = object.contractAddress) !== null && _a !== void 0 ? _a : "";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryEVMMarketResponse = {
    name: "",
    displayName: "",
    marketType: "",
    base: "",
    quote: "",
    basePrecision: long_1.default.ZERO,
    quotePrecision: long_1.default.ZERO,
    minQuantity: "",
    isActive: false,
};
exports.QueryEVMMarketResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.displayName !== "") {
            writer.uint32(18).string(message.displayName);
        }
        if (message.marketType !== "") {
            writer.uint32(26).string(message.marketType);
        }
        if (message.base !== "") {
            writer.uint32(34).string(message.base);
        }
        if (message.quote !== "") {
            writer.uint32(42).string(message.quote);
        }
        if (!message.basePrecision.isZero()) {
            writer.uint32(48).int64(message.basePrecision);
        }
        if (!message.quotePrecision.isZero()) {
            writer.uint32(56).int64(message.quotePrecision);
        }
        if (message.minQuantity !== "") {
            writer.uint32(66).string(message.minQuantity);
        }
        if (message.isActive === true) {
            writer.uint32(72).bool(message.isActive);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryEVMMarketResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.displayName = reader.string();
                    break;
                case 3:
                    message.marketType = reader.string();
                    break;
                case 4:
                    message.base = reader.string();
                    break;
                case 5:
                    message.quote = reader.string();
                    break;
                case 6:
                    message.basePrecision = reader.int64();
                    break;
                case 7:
                    message.quotePrecision = reader.int64();
                    break;
                case 8:
                    message.minQuantity = reader.string();
                    break;
                case 9:
                    message.isActive = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryEVMMarketResponse);
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        message.displayName =
            object.displayName !== undefined && object.displayName !== null
                ? String(object.displayName)
                : "";
        message.marketType =
            object.marketType !== undefined && object.marketType !== null
                ? String(object.marketType)
                : "";
        message.base =
            object.base !== undefined && object.base !== null
                ? String(object.base)
                : "";
        message.quote =
            object.quote !== undefined && object.quote !== null
                ? String(object.quote)
                : "";
        message.basePrecision =
            object.basePrecision !== undefined && object.basePrecision !== null
                ? long_1.default.fromString(object.basePrecision)
                : long_1.default.ZERO;
        message.quotePrecision =
            object.quotePrecision !== undefined && object.quotePrecision !== null
                ? long_1.default.fromString(object.quotePrecision)
                : long_1.default.ZERO;
        message.minQuantity =
            object.minQuantity !== undefined && object.minQuantity !== null
                ? String(object.minQuantity)
                : "";
        message.isActive =
            object.isActive !== undefined && object.isActive !== null
                ? Boolean(object.isActive)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.displayName !== undefined &&
            (obj.displayName = message.displayName);
        message.marketType !== undefined && (obj.marketType = message.marketType);
        message.base !== undefined && (obj.base = message.base);
        message.quote !== undefined && (obj.quote = message.quote);
        message.basePrecision !== undefined &&
            (obj.basePrecision = (message.basePrecision || long_1.default.ZERO).toString());
        message.quotePrecision !== undefined &&
            (obj.quotePrecision = (message.quotePrecision || long_1.default.ZERO).toString());
        message.minQuantity !== undefined &&
            (obj.minQuantity = message.minQuantity);
        message.isActive !== undefined && (obj.isActive = message.isActive);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = Object.assign({}, baseQueryEVMMarketResponse);
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.displayName = (_b = object.displayName) !== null && _b !== void 0 ? _b : "";
        message.marketType = (_c = object.marketType) !== null && _c !== void 0 ? _c : "";
        message.base = (_d = object.base) !== null && _d !== void 0 ? _d : "";
        message.quote = (_e = object.quote) !== null && _e !== void 0 ? _e : "";
        message.basePrecision =
            object.basePrecision !== undefined && object.basePrecision !== null
                ? long_1.default.fromValue(object.basePrecision)
                : long_1.default.ZERO;
        message.quotePrecision =
            object.quotePrecision !== undefined && object.quotePrecision !== null
                ? long_1.default.fromValue(object.quotePrecision)
                : long_1.default.ZERO;
        message.minQuantity = (_f = object.minQuantity) !== null && _f !== void 0 ? _f : "";
        message.isActive = (_g = object.isActive) !== null && _g !== void 0 ? _g : false;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Market = this.Market.bind(this);
        this.MarketAll = this.MarketAll.bind(this);
        this.TradingFees = this.TradingFees.bind(this);
        this.FeeTiers = this.FeeTiers.bind(this);
        this.StakeEquivalenceAll = this.StakeEquivalenceAll.bind(this);
        this.FeeStructuresAll = this.FeeStructuresAll.bind(this);
        this.UserFeeStructures = this.UserFeeStructures.bind(this);
        this.Params = this.Params.bind(this);
        this.ControlledParams = this.ControlledParams.bind(this);
        this.EVMMarket = this.EVMMarket.bind(this);
    }
    Market(request) {
        const data = exports.QueryGetMarketRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.market.Query", "Market", data);
        return promise.then((data) => exports.QueryGetMarketResponse.decode(new minimal_1.default.Reader(data)));
    }
    MarketAll(request) {
        const data = exports.QueryAllMarketRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.market.Query", "MarketAll", data);
        return promise.then((data) => exports.QueryAllMarketResponse.decode(new minimal_1.default.Reader(data)));
    }
    TradingFees(request) {
        const data = exports.QueryGetTradingFeesRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.market.Query", "TradingFees", data);
        return promise.then((data) => exports.QueryGetTradingFeesResponse.decode(new minimal_1.default.Reader(data)));
    }
    FeeTiers(request) {
        const data = exports.QueryGetFeeTiersRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.market.Query", "FeeTiers", data);
        return promise.then((data) => exports.QueryGetFeeTiersResponse.decode(new minimal_1.default.Reader(data)));
    }
    StakeEquivalenceAll(request) {
        const data = exports.QueryAllStakeEquivalenceRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.market.Query", "StakeEquivalenceAll", data);
        return promise.then((data) => exports.QueryAllStakeEquivalenceResponse.decode(new minimal_1.default.Reader(data)));
    }
    FeeStructuresAll(request) {
        const data = exports.QueryAllFeeStructuresRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.market.Query", "FeeStructuresAll", data);
        return promise.then((data) => exports.QueryAllFeeStructuresResponse.decode(new minimal_1.default.Reader(data)));
    }
    UserFeeStructures(request) {
        const data = exports.QueryUserFeeStructuresRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.market.Query", "UserFeeStructures", data);
        return promise.then((data) => exports.QueryUserFeeStructuresResponse.decode(new minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.market.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    ControlledParams(request) {
        const data = exports.QueryControlledParamsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.market.Query", "ControlledParams", data);
        return promise.then((data) => exports.QueryControlledParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    EVMMarket(request) {
        const data = exports.QueryEVMMarketRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.market.Query", "EVMMarket", data);
        return promise.then((data) => exports.QueryEVMMarketResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
